import { Model } from '@/models/Model';
export class Mfa extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'Mfa';
        this.$endpoint = '/mfa';
        this.$fillable = [];
    }
}
